import {LogoSuiteMap as sharedLogoMap} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'
import {MicrosoftLogo} from './MicrosoftLogo'
import {AzureLogo} from './AzureLogo'
import {VisualStudioCodeLogo} from './VisualStudioCodeLogo'
import {MicrosoftCopilotLogo} from './MicrosoftCopilotLogo'

/**
 * Map of FlexSuite and shared Contentful logo name strings to React SVG components.
 *
 * Shared logos come from swp-core's ContentfulLogoSuite entrypoint so
 * IntroSection can reuse the larger Contentful-backed logo set, while
 * FlexSuite-specific logos remain defined here.
 */
export const logoMap: {[key: string]: () => React.ReactElement} = {
  ...sharedLogoMap,
  Microsoft: MicrosoftLogo,
  Azure: AzureLogo,
  'Visual Studio Code': VisualStudioCodeLogo,
  'Microsoft Copilot': MicrosoftCopilotLogo,
}

/**
 * File name of the pre-rendered `.svg` asset for a logo.
 *
 * Shared by `script/generate-logo-assets.tsx` and its drift test so the two cannot disagree about
 * which asset belongs to which logo.
 */
export function logoAssetFileName(logoName: string): string {
  const slug = logoName
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase()

  if (!slug) throw new Error(`Cannot derive an asset file name for logo "${logoName}".`)
  return `${slug}.svg`
}
